<div class="container" [class.is-condensed]="!showMainContent">
  <div class="search-container">
    <app-search-bar
      [query]="query"
      [placeholder]="searchPlaceholder"
      [clearLabel]="translate('clearSearch')"
      [countyLabel]="translate('county')"
      [cityLabel]="translate('city')"
      [suggestions]="useQuickResultsDropdown ? [] : locationSuggestions"
      [useResultDropdown]="useQuickResultsDropdown"
      [resultItems]="quickResults"
      (queryChange)="onQueryChange($event)"
      (clear)="onClearSearch()"
      (resultSelected)="onQuickResultSelected($event)"
      (searchSubmit)="onSearchSubmit()"
    ></app-search-bar>
    <app-trending-searches
      *ngIf="useQuickResultsDropdown && !query"
      (termSelected)="onTrendingTermSelected($event)"
    ></app-trending-searches>
  </div>
  <!-- WiseVoice embedded chat - DISABLED for now
  <div
    id="wisevoice_embedded_chat"
    class="wisevoice-chat-container"
    [class.wisevoice-hidden]="!searchSubmitted"
  ></div>
  -->
  <div class="main-content" *ngIf="showMainContent">
    <!-- Mobile: Full-width control bar with filter toggle icon -->
    <div class="mobile-control-bar" *ngIf="isMobileView">
      <div class="mobile-control-left">
        <button
          *ngIf="!hideFacets"
          type="button"
          class="mobile-filter-toggle-btn"
          (click)="toggleFiltersPanel()"
          [attr.aria-expanded]="showFiltersPanel"
          [attr.aria-label]="translate('toggleFilters')"
          [attr.title]="translate('toggleFilters')"
        >
          <span class="material-symbols-outlined" aria-hidden="true">
            {{ showFiltersPanel ? 'filter_list_off' : 'filter_list' }}
          </span>
          <span class="mobile-filter-label">{{ translate('filterTitle') }}</span>
        </button>
      </div>
      <div class="mobile-control-right">
        <div class="mobile-sort-control">
          <label for="mobile-sort-select" class="mobile-sort-label">{{ translate('sortBy') }}:</label>
          <select id="mobile-sort-select" class="mobile-sort-select" (change)="onMobileSortChange($event)" [value]="currentSort">
            <option value="score desc">{{ translate('sortRelevance') }}</option>
            <option value="nume_str asc">{{ translate('sortNameAsc') }}</option>
            <option value="nume_str desc">{{ translate('sortNameDesc') }}</option>
          </select>
        </div>
      </div>
      <span class="results-summary mobile-results-summary" *ngIf="resultsSummaryText">{{ resultsSummaryText }}</span>
    </div>

    <!-- Mobile: Selected filters chips -->
    <div class="mobile-selected-filters" *ngIf="isMobileView && selectedChips.length">
      <button
        *ngFor="let chip of selectedChips"
        type="button"
        class="selected-filter-chip"
        [ngClass]="chip.cssClass"
        (click)="onRemoveFilter({facetKey: chip.facetKey, value: chip.value})"
      >
        <span class="selected-filter-label">{{ chip.label | capitalize }}</span>
        <span aria-hidden="true">×</span>
      </button>
      <button type="button" class="mobile-clear-filters" (click)="onClearFilters()">
        {{ translate('clearFilters') }}
      </button>
    </div>

    <!-- Mobile: Sidebar (filters panel) - appears below control bar when visible -->
    <aside
      class="sidebar mobile-sidebar"
      *ngIf="isMobileView && showFiltersPanel && !hideFacets"
      id="filters-panel"
    >
      <div class="filters-title">{{ translate('filterTitle') }}</div>
      <app-facet-section
        *ngFor="let config of visibleFacetConfigs"
        [facetKey]="config.key"
        [title]="translate(config.translationKey)"
        [values]="facets[config.key] || {}"
        [selectedValues]="filters[config.key] || []"
        [allFacetLabels]="facetLabels"
        [showSearch]="config.showSearch"
        (toggle)="onFacetToggle(config.key, $event)"
      ></app-facet-section>
    </aside>

    <!-- Desktop: Standard sidebar -->
    <aside
      class="sidebar"
      *ngIf="!isMobileView && showFiltersPanel && !hideFacets"
    >
      <div class="filters-title">{{ translate('filterTitle') }}</div>
      <app-facet-section
        *ngFor="let config of visibleFacetConfigs"
        [facetKey]="config.key"
        [title]="translate(config.translationKey)"
        [values]="facets[config.key] || {}"
        [selectedValues]="filters[config.key] || []"
        [allFacetLabels]="facetLabels"
        [showSearch]="config.showSearch"
        (toggle)="onFacetToggle(config.key, $event)"
      ></app-facet-section>
    </aside>

    <main class="results-container">
        <app-selected-filters
        *ngIf="!isMobileView"
        [chips]="selectedChips"
        [sort]="currentSort"
        [showFiltersPanel]="showFiltersPanel"
        [hideFilterToggle]="hideFacets"
        [resultsSummaryText]="resultsSummaryText"
        (remove)="onRemoveFilter($event)"
        (clear)="onClearFilters()"
        (sortChange)="onSortChange($event)"
        (toggleFilters)="onToggleFilters()"
      ></app-selected-filters>

      <div *ngIf="loading" class="loading-state">{{ translate('loading') }}</div>
      <div *ngIf="error" class="error-state">{{ translate('errorLoading') }} ({{ error }})</div>

      <app-results-list
        [results]="results"
        [loading]="loading"
        [hideFacets]="hideFacets"
        (resultClick)="onResultClicked($event)"
      ></app-results-list>

      <app-pagination
        [total]="total"
        [page]="page"
        [rows]="resultsPerPage"
        (pageChange)="onPageChange($event)"
      ></app-pagination>

      <p *ngIf="isEnglish" class="translation-disclaimer">
        *Content marked with an asterisk (*) has been automatically translated and may not fully reflect the original meaning. For objective interpretation, please consult the Romanian version.
      </p>
    </main>
  </div>
</div>
